import type { SortingDirType } from '@/api/request'
import { useSearchParams } from 'react-router'

const useFiltering = <T extends string[]>(
  resetPagination?: () => void
) => {
  const [searchParams, setSearchParams] = useSearchParams()

  // NOTE: Uncomment if you want to update filters based on API initial response
  // const updateFiltersFromAPI = (newFilters?: FilterParamsType) => {
  //   if (!newFilters) return
  //   const newSortBy = newFilters.appliedSort ? Object.keys(newFilters.appliedSort)[0] : undefined
  //   const newSortDir = newFilters.appliedSort ? Object.values(newFilters.appliedSort)[0] : undefined

  //   const oldParams = searchParams.toString()
  //   const nextParams = new URLSearchParams(oldParams)
  //   if (newSortBy !== searchParams.get('sortBy')) {
  //     if (newSortBy) {
  //       nextParams.set('sortBy', newSortBy)
  //     } else {
  //       nextParams.delete('sortBy')
  //     }
  //   }
  //   if (newSortDir !== searchParams.get('sortDir')) {
  //     if (newSortDir) {
  //       nextParams.set('sortDir', newSortDir)
  //     } else {
  //       nextParams.delete('sortDir')
  //     }
  //   }
  //   if (oldParams !== nextParams.toString()) {
  //     setSearchParams(nextParams)
  //   }
  // }

  const updateSortBy = (newSortBy: string, newDir?: SortingDirType) => {
    const oldSortBy = searchParams.get('sortBy')
    const oldDir = searchParams.get('sortDir')
    if (newSortBy === oldSortBy && newDir === oldDir) return

    const nextParams = new URLSearchParams(searchParams.toString())
    if (newSortBy) nextParams.set('sortBy', newSortBy)
    else nextParams.delete('sortBy')
    if (newDir) nextParams.set('sortDir', newDir)
    else nextParams.delete('sortDir')
    setSearchParams(nextParams)
    resetPagination?.()
  }

  const updateFilterBy = (key: T[number], value: string) => {
    const oldValue = searchParams.get(key as string)
    if (value === oldValue) return

    const nextParams = new URLSearchParams(searchParams.toString())
    if (value) {
      nextParams.set(key as string, value)
      if (key !== 'page') nextParams.set('page', '1')
    } else {
      nextParams.delete(key as string)
    }
    setSearchParams(nextParams)
    resetPagination?.()
  }

  const sortBy = searchParams.get('sortBy') || undefined
  const sortDir = (searchParams.get('sortDir') || undefined) as SortingDirType | undefined

  return {
    updateSortBy,
    updateFilterBy,
    sortBy,
    sortDir,
    allFilters: Object.fromEntries(searchParams.entries()) as Record<T[number], string>,
  }
}
export default useFiltering
